/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyInsuranceSettingsCreateSchema } from '../models/CompanyInsuranceSettingsCreateSchema';
import type { CompanyInsuranceSettingsDetailSchema } from '../models/CompanyInsuranceSettingsDetailSchema';
import type { CompanyInsuranceSettingsListSchema } from '../models/CompanyInsuranceSettingsListSchema';
import type { CompanyInsuranceSettingsUpdateSchema } from '../models/CompanyInsuranceSettingsUpdateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyInsuranceSettingsApi {
    /**
     * List Company Insurance Settings
     * List insurance settings, one per IČZ. <br>Required permission: list_my_company_insurance_settings
     * @returns CompanyInsuranceSettingsListSchema OK
     * @throws ApiError
     */
    public static insuranceListCompanyInsuranceSettingsGet(): CancelablePromise<Array<CompanyInsuranceSettingsListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company-insurance-settings/',
        });
    }
    /**
     * Create Company Insurance Settings
     * Create company insurance settings. <br>Required permission: edit_company_details
     * @returns CompanyInsuranceSettingsDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateCompanyInsuranceSettingsPost({
        requestBody,
    }: {
        requestBody: CompanyInsuranceSettingsCreateSchema,
    }): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company-insurance-settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Insurance Settings Detail
     * Get company insurance settings detail. <br>Required permission: list_my_company_insurance_settings
     * @returns CompanyInsuranceSettingsDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetCompanyInsuranceSettingsDetailGet({
        companyInsuranceSettingsId,
    }: {
        companyInsuranceSettingsId: string,
    }): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company-insurance-settings/{company_insurance_settings_id}/',
            path: {
                'company_insurance_settings_id': companyInsuranceSettingsId,
            },
        });
    }
    /**
     * Update Company Insurance Settings
     * Update company insurance settings. <br>Required permission: edit_company_details
     * @returns CompanyInsuranceSettingsDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateCompanyInsuranceSettingsPut({
        companyInsuranceSettingsId,
        requestBody,
    }: {
        companyInsuranceSettingsId: string,
        requestBody: CompanyInsuranceSettingsUpdateSchema,
    }): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company-insurance-settings/{company_insurance_settings_id}/',
            path: {
                'company_insurance_settings_id': companyInsuranceSettingsId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Company Insurance Settings
     * Delete company insurance settings without workspaces. <br>Required permission: edit_company_details
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteCompanyInsuranceSettingsDelete({
        companyInsuranceSettingsId,
    }: {
        companyInsuranceSettingsId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company-insurance-settings/{company_insurance_settings_id}/',
            path: {
                'company_insurance_settings_id': companyInsuranceSettingsId,
            },
        });
    }
}
